module.exports = __webpack_public_path__ + "static/media/cyber-darkweb.2bddd350.svg";